import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useDeleteRecipient(options = {}) {
  const { accessToken } = useSession();
  const cache = useQueryClient();

  const mutation = useMutation(
    async ({ id }) => {
      return axios.delete(
        `${config.customerProfileApiUrl}/v1/recipients/${id}`,
        {
          headers: {
            ...requestHeaders(accessToken),
            "Content-Type": "application/json",
          },
        },
      );
    },
    {
      onSuccess: () => {
        cache.invalidateQueries("notification-recipients");
      },
      ...options,
    },
  );

  return {
    delete: mutation.mutateAsync,
    deleteStatus: mutation,
  };
}
